import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from "@/config/api"
import alert from "@/_module/alert/install"
import _login from "@/_module/login_sdk/install"
import tools from "@/public/tools.js"
import axios from '@/config/http'
// import GLOBAL from './GLOBAL.vue'
import imgList from '@/public/imgGlobal.js'
import elementUI from '@/public/element-ui.js'
//import VueI18n from "vue-i18n"
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$tools = tools;
Vue.prototype.$http = axios;
let bus = new Vue()
Vue.prototype.$bus = bus
// Vue.prototype.GLOBAL = GLOBAL;
// Vue.prototype.LANG = GLOBAL.LANG; 
// Vue.prototype.LANG.resoleLANG = function(key,values){
// 	if(values) return tools.resoleLANG(GLOBAL.LANG[key],values);
// 	return GLOBAL.LANG[key];
// }
// Vue.prototype.MLANG = GLOBAL.MLANG;
Vue.prototype.$imgList = imgList;

//當前頁面
if(window.STAY){
	Vue.prototype.STAY = window.STAY;
}
//使用全局组件
Vue.use(alert);
Vue.use(_login);
//Vue.use(VueI18n);
//const language = tools.getCookie("think_var");
//多語言配置
/* const i18n = new VueI18n({
	locale: language || "en-us",
	messages: {
		'ja-jp': require('./language/jp'),
		'en-us': require('./language/en')
	}
}); */
Vue.config.devtools = process.env.ENV === 'production' ? false : true
new Vue({
  router,
  store,
  //i18n,
  render: h => h(App)
}).$mount('#app')
